import {Link, Text} from '@forecast-it/design-system';
import React from 'react';
import {dispatch, EVENT_ID} from '../../../../../../containers/event_manager';
import {trackEvent} from '../../../../../../tracking/amplitude/TrackingV2';
import styled from 'styled-components';

// FIXME: hack until font-weight is added to DS
const TextStyleOverride = styled.div`
	div {
		font-weight: 600;
	}
`;

export type EmptyStateTaskNameProps = {
	hasSuggestions: boolean;
	filterActive: boolean;
	searchActive: boolean;
	additionalClasses: string;
	usingCurrentUserAssigneeFilter: boolean;
};
export const EmptyStateTaskName = ({
	filterActive,
	searchActive,
	additionalClasses,
	usingCurrentUserAssigneeFilter,
}: EmptyStateTaskNameProps): React.ReactElement => {
	const usingCurrentUserAssigneeFilterMessage = 'It looks like there’s no work assigned to you';
	const genericNotFoundMessage = 'We cannot find what you are looking for';

	if (searchActive) {
		return (
			<div className={'elem-wrapper empty-state' + additionalClasses} style={{overflow: 'visible'}}>
				<div style={{display: 'flex', flexDirection: 'column'}}>
					<TextStyleOverride>
						<Text noWrap>{genericNotFoundMessage}</Text>
					</TextStyleOverride>
					<Text noWrap color={'medium'}>
						<Link
							onClick={() => {
								trackEvent('Clear Search Query Link', 'Clicked');
								dispatch(EVENT_ID.CLEAR_SEARCH);
							}}
						>
							Try clearing the search query
						</Link>
					</Text>
				</div>
			</div>
		);
	}

	if (filterActive) {
		return (
			<div className={'elem-wrapper empty-state' + additionalClasses} style={{overflow: 'visible'}}>
				<div style={{display: 'flex', flexDirection: 'column'}}>
					<TextStyleOverride>
						<Text noWrap>
							{usingCurrentUserAssigneeFilter ? usingCurrentUserAssigneeFilterMessage : genericNotFoundMessage}
						</Text>
					</TextStyleOverride>
					<Text noWrap color={'medium'}>
						<Link
							onClick={() => {
								trackEvent('Clear Filters Link', 'Clicked');
								dispatch(EVENT_ID.CLEAR_FILTERS);
							}}
						>
							Try clearing the filters
						</Link>
					</Text>
				</div>
			</div>
		);
	}

	return (
		<div className={'elem-wrapper empty-state' + additionalClasses} style={{overflow: 'visible'}}>
			<div style={{display: 'flex', flexDirection: 'column'}}>
				<TextStyleOverride>
					<Text noWrap>{genericNotFoundMessage}</Text>
				</TextStyleOverride>
				<Text noWrap color={'medium'}>
					Try to adjust your search terms or filters.
				</Text>
			</div>
		</div>
	);
};
